export const homeMetatags = {
	title: 'Giveth: Future of Giving with Zero-Fee Crypto Donation',
	desc: 'Get rewarded for crypto donations to for-good projects with zero added fees and accepting crypto donations. Donate crypto directly to thousands of nonprofits & charities!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmQ9sfdevs9vS7czBXBfDaRRPhU8a6T5gXxF3NDGSnQe1c',
	url: 'https://giveth.io/',
};

export const givfarmMetatags = {
	title: 'GIVfarm: Stake-to-earn while supporting for-good DAOs',
	desc: 'Get crypto rewards by providing liquidity and supporting the GIVeconomy. Support Regen projects and kickstart your UBI-esque reward streams!',
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/givfarm',
};

export const aboutMetatags = {
	title: 'About Giveth: Mission, Vision & Values',
	desc: 'Giveth is a community focused on Building the Future of Giving using crypto & blockchain technology. Learn about our mission, vision & values.',
	image: 'https://giveth.mypinata.cloud/ipfs/QmQ9sfdevs9vS7czBXBfDaRRPhU8a6T5gXxF3NDGSnQe1c',
	url: 'https://giveth.io/about',
};

export const givstreamMetatags = {
	title: 'GIVstream: Get more GIV/week until the end of 2026',
	desc: 'Want to earn crypto reward stream by doing good? Support the GIVeconomy to earn rewards and kickstart your GIV/week flowrate.',
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/givstream',
};

export const givpowerMetatags = {
	title: 'GIVpower: Boost Projects with GIVpower',
	desc: 'With GIVpower, you can support verified projects, while earning rewards on your GIV.',
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/givpower',
};

export const projectsMetatags = {
	title: 'Give directly to for-good projects with crypto & zero fees',
	desc: 'Support for-good projects, nonprofits & charities with crypto donations. Give directly with zero added fees. Get rewarded when you donate to verified projects!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmQ9sfdevs9vS7czBXBfDaRRPhU8a6T5gXxF3NDGSnQe1c',
	url: 'https://giveth.io/projects',
};

export const givbacksMetatags = {
	title: 'GIVbacks: Get rewarded for donating to verified projects',
	desc: 'GIVbacks rewards donors to verified projects with GIV, super-charging Giveth as a donor-driven force for good. GIVbacks is only available on Gnosis Chain.',
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/givbacks',
};

export const giveconomyMetatags = {
	title: 'GIVeconomy: Empowering our collective to build the Future of Giving.',
	desc: 'Giveth is a donor owned and governed economy. With GIVbacks, we reward donors to verified projects on Giveth with GIV. ',
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/giveconomy',
};

export const supportMetatags = {
	title: 'Need Support? The Giveth team is here Help',
	desc: `Have a question? Need to report an issue, leave feedback or request a new feature? We're here and we'd love to hear from you!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/support',
};

export const partnershipMetatags = {
	title: 'Learn about the partners helping us build the Future of Giving',
	desc: `Learn more about our partnerships & friends in the Ethereum Community helping us build the Future of Giving. From Gnosis Chain to 1Hive, ShapeShift DAO & more!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/partnerships',
};

export const joinMetatags = {
	title: 'Join Giveth and contribute to the Future of Giving!',
	desc: `Learn the best ways to get involved with Giveth. From joining our discord, participating in governance, contributing part time or even full time roles with us!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/join',
};

export const faqMetatags = {
	title: 'FAQ (Frequently Asked Questions) | Giveth',
	desc: `Get your questions answered, and learn about key definitions about Blockchain in general, Giveth, and the GIVeconomy!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/faq',
};

export const createProjectMetatags = {
	title: 'Create a Project on Giveth with Zero Fees',
	desc: `Post your for-good or nonprofit project to start raising money through crypto for free with zero added fees + donors get rewarded when you verify your project!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/create',
};

export const claimMetatags = {
	title: 'Claim Your GIVdrop!',
	desc: `If you were an early supporter of Giveth before our public launch, enter your address to check if you are eligible for our GIVdrop!`,
	image: 'https://i.ibb.co/HTbdCdd/Thumbnail.png',
	url: 'https://giveth.io/claim',
};

export const nftMetatags = {
	title: 'Givers PFP Collection',
	desc: 'Mint a Giver and show off your support for the Future of Giving!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmULaTJR5KHZeaDQ26p1ALcwAKgMcZGqVqGejPwbcmRwYc',
	url: 'https://giveth.io/nft',
};

export const generalOnboardingMetaTags = {
	title: 'Giveth Onboarding | Intro',
	desc: 'Learn how to use the Giveth platform like a pro with this onboarding guide!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmX2242gXzRp5tHWGkJu5L5VbgWD6Fu4NDbLunBhCKBEtY/General%20banner.svg',
	url: 'https://giveth.io/onboarding',
};

export const projectOnboardingMetaTags = {
	title: 'Giveth Onboarding | Projects',
	desc: 'Learn how to manage your Giveth project like a pro with this onboarding guide!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmX2242gXzRp5tHWGkJu5L5VbgWD6Fu4NDbLunBhCKBEtY/project%20banner.svg',
	url: 'https://giveth.io/onboarding/projects',
};

export const donorOnboardingMetaTags = {
	title: ' Giveth Onboarding | Donors',
	desc: 'Learn how to use the Giveth platform like a pro with this onboarding guide!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmX2242gXzRp5tHWGkJu5L5VbgWD6Fu4NDbLunBhCKBEtY/Donate%20banner.svg',
	url: 'https://giveth.io/onboarding/donors',
};

export const giveconomyOnboardingMetaTags = {
	title: 'Giveth Onboarding | GIVeconomy',
	desc: 'Learn how to use the GIVeconomy like a pro with this onboarding guide!',
	image: 'https://giveth.mypinata.cloud/ipfs/QmX2242gXzRp5tHWGkJu5L5VbgWD6Fu4NDbLunBhCKBEtY/GIVecon%20banner.svg',
	url: 'https://giveth.io/onboarding/giveconomy',
};
